export default __webpack_public_path__ + "static/sun-chasers-mobile-93d663c0d027e1113095f4b2b613341a.webp";